export enum HeaderSize {
    SMALL = 0,
    LARGE = 1,
}
